/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: ohP9gHR_8Wi

import * as React from "react";

import {
  Flex as Flex__,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ProjectListItem from "../../components/ProjectListItem"; // plasmic-import: 2FvZipCkyxl/component
import DefaultLayout from "../../components/dashboard/DefaultLayout"; // plasmic-import: nSkQWLjK-B/component
import NavTeamSection from "../../components/dashboard/NavTeamSection"; // plasmic-import: VqaN_WL-stA/component
import WorkspaceSection from "../../components/dashboard/WorkspaceSection"; // plasmic-import: 5cdjGaqBQ4/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicWorkspacePage.module.css"; // plasmic-import: ohP9gHR_8Wi/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  },
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    },
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary" as const,
    },
  };
}

createPlasmicElementProxy;

export type PlasmicWorkspacePage__VariantMembers = {};
export type PlasmicWorkspacePage__VariantsArgs = {};
type VariantPropType = keyof PlasmicWorkspacePage__VariantsArgs;
export const PlasmicWorkspacePage__VariantProps = new Array<VariantPropType>();

export type PlasmicWorkspacePage__ArgsType = {};
type ArgPropType = keyof PlasmicWorkspacePage__ArgsType;
export const PlasmicWorkspacePage__ArgProps = new Array<ArgPropType>();

export type PlasmicWorkspacePage__OverridesType = {
  root?: Flex__<"div">;
  defaultLayout?: Flex__<typeof DefaultLayout>;
  workspaceSection?: Flex__<typeof WorkspaceSection>;
  navTeamSection?: Flex__<typeof NavTeamSection>;
};

export interface DefaultWorkspacePageProps {
  className?: string;
}

const $$ = {};

function PlasmicWorkspacePage__RenderFunc(props: {
  variants: PlasmicWorkspacePage__VariantsArgs;
  args: PlasmicWorkspacePage__ArgsType;
  overrides: PlasmicWorkspacePage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_ooL7EhXDmFQWnW9sxtchhE",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <DefaultLayout
            data-plasmic-name={"defaultLayout"}
            data-plasmic-override={overrides.defaultLayout}
            className={classNames("__wab_instance", sty.defaultLayout)}
            hideNewProjectButton={true}
            teams={
              <NavTeamSection
                data-plasmic-name={"navTeamSection"}
                data-plasmic-override={overrides.navTeamSection}
                className={classNames("__wab_instance", sty.navTeamSection)}
              />
            }
          >
            <WorkspaceSection
              data-plasmic-name={"workspaceSection"}
              data-plasmic-override={overrides.workspaceSection}
              className={classNames("__wab_instance", sty.workspaceSection)}
            >
              <ProjectListItem />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem__seC2O
                )}
              />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem__qnZxn
                )}
              />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem__dNcjL
                )}
              />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem__fs4Vv
                )}
              />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem___4BZuv
                )}
              />

              <ProjectListItem
                className={classNames(
                  "__wab_instance",
                  sty.projectListItem__sLb7K
                )}
              />
            </WorkspaceSection>
          </DefaultLayout>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "defaultLayout", "workspaceSection", "navTeamSection"],
  defaultLayout: ["defaultLayout", "workspaceSection", "navTeamSection"],
  workspaceSection: ["workspaceSection"],
  navTeamSection: ["navTeamSection"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  defaultLayout: typeof DefaultLayout;
  workspaceSection: typeof WorkspaceSection;
  navTeamSection: typeof NavTeamSection;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicWorkspacePage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicWorkspacePage__VariantsArgs;
    args?: PlasmicWorkspacePage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicWorkspacePage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicWorkspacePage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWorkspacePage__ArgProps,
          internalVariantPropNames: PlasmicWorkspacePage__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicWorkspacePage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWorkspacePage";
  } else {
    func.displayName = `PlasmicWorkspacePage.${nodeName}`;
  }
  return func;
}

export const PlasmicWorkspacePage = Object.assign(
  // Top-level PlasmicWorkspacePage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    defaultLayout: makeNodeComponent("defaultLayout"),
    workspaceSection: makeNodeComponent("workspaceSection"),
    navTeamSection: makeNodeComponent("navTeamSection"),

    // Metadata about props expected for PlasmicWorkspacePage
    internalVariantProps: PlasmicWorkspacePage__VariantProps,
    internalArgProps: PlasmicWorkspacePage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/workspaces/[id]",
      pagePath: "/workspaces/[id]",
      params: {},
      query: {},
    }),
  }
);

export default PlasmicWorkspacePage;
/* prettier-ignore-end */
